import { AxiosRequest } from "_services/api";
import { HttpError } from "_services/api/HttpError";
import { HttpResponse } from "_services/api/HttpResponse";
import {
  IData,
  IHttpError,
  IHttpResponse,
} from "_services/api/interface/HttpResponse";
import { getToken } from "_services/auth";
import { alertaErro } from "components/Alerta";
import { useState } from "react";
import { IExtracaoXml } from "../interfaces/IExtracaoXml";

export function useExtracaoXml() {
  const api = AxiosRequest.makeApi(process.env.REACT_APP_MS_AW);
  const token = getToken();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<IHttpResponse<IData | any>>();

  async function extrairXmls(dados: IExtracaoXml) {
    setLoading(true);
    try {
      const { status, data } = await api.post(
        `/emplacamento/xml/filtrar`,
        dados,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      );

      const response = new HttpResponse(false, status, data);
      const nomeArquivo = `XmlFiltrados_${Date.now()}.zip`;
      const url = window.URL.createObjectURL(
        new Blob([data], { type: "application/zip" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nomeArquivo);
      document.body.appendChild(link);
      link.click();
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      alertaErro(
        "Ocorreu um erro",
        response?.data?.message ?? "Não foi possivel geral ZIP"
      );
      return response;
    } finally {
      setLoading(false);
    }
  }

  return {
    error,
    setLoading,
    loading,
    extrairXmls,
  };
}
